import { useRef, useEffect, useState } from "react"
import SendModalComponent from "./SendModalComponent"

export default function Comment() {
    const [activeRadio, setActiveRadio] = useState(false)
    const [isShowCommentB1, setIsShowCommentB1] = useState(false)
    const [isShowCommentB2, setIsShowCommentB2] = useState(false)
    const [open, setOpen] = useState(false)
    return (
        <div className="styles_comment__tvkRA">
            <div className="styles_actionComment__s5JCB MuiBox-root css-0">
                <div className="styles_titleComment__MnezQ MuiBox-root css-0">
                    <div className="styles_logo__ONLCd MuiBox-root css-0">
                        <span
                            style={{
                                boxSizing: 'border-box',
                                display: 'inline-block',
                                overflow: 'hidden',
                                width: 'initial',
                                height: 'initial',
                                background: 'none',
                                opacity: 1,
                                border: '0px',
                                margin: '0px',
                                padding: '0px',
                                position: 'relative',
                                maxWidth: '100%'
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: 'border-box',
                                    display: 'block',
                                    width: 'initial',
                                    height: 'initial',
                                    background: 'none',
                                    opacity: 1,
                                    border: '0px',
                                    margin: '0px',
                                    padding: '0px',
                                    maxWidth: '100%'
                                }}
                            >
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2732%27%20height=%2732%27/%3e"
                                    style={{
                                        display: 'block',
                                        maxWidth: '100%',
                                        width: 'initial',
                                        height: 'initial',
                                        background: 'none',
                                        opacity: 1,
                                        border: '0px',
                                        margin: '0px',
                                        padding: '0px'
                                    }} />
                            </span>
                            <img
                                src="https://cdn-web-next.thuocsi.vn/images/logo_qa.svg"
                                decoding="async"
                                data-nimg="intrinsic"
                                style={{
                                    position: 'absolute',
                                    inset: '0px',
                                    boxSizing: 'border-box',
                                    padding: '0px',
                                    border: 'none',
                                    margin: 'auto',
                                    display: 'block',
                                    width: '0px',
                                    height: '0px',
                                    minWidth: '100%',
                                    maxWidth: '100%',
                                    minHeight: '100%',
                                    maxHeight: '100%'
                                }}
                            />
                        </span>
                    </div>
                    <p className="MuiTypography-root styles_headingComment__Rzl_3 MuiTypography-body1">
                        Ý kiến về sản phẩm <span>(5 ý kiến)</span>
                    </p>
                </div>
                <button className="styles_base__Pdm9S styles_contained__4kDf4 styles_colorGreenish__fz_CF styles_small__QTUmD" onClick={() => setOpen(true)}>
                    <span className="styles_icon__ucPkH">
                        <span
                            style={{
                                boxSizing: 'border-box',
                                display: 'inline-block',
                                overflow: 'hidden',
                                width: 'initial',
                                height: 'initial',
                                background: 'none',
                                opacity: 1,
                                border: '0px',
                                margin: '0px',
                                padding: '0px',
                                position: 'relative',
                                maxWidth: '100%'
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: 'border-box',
                                    display: 'block',
                                    width: 'initial',
                                    height: 'initial',
                                    background: 'none',
                                    opacity: 1,
                                    border: '0px',
                                    margin: '0px',
                                    padding: '0px',
                                    maxWidth: '100%'
                                }}
                            >
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e"
                                    style={{
                                        display: 'block',
                                        maxWidth: '100%',
                                        width: 'initial',
                                        height: 'initial',
                                        background: 'none',
                                        opacity: 1,
                                        border: '0px',
                                        margin: '0px',
                                        padding: '0px'
                                    }} />
                            </span>
                            <img
                                src="https://cdn-web-next.thuocsi.vn/images/send_btn_qa.svg"
                                decoding="async"
                                data-nimg="intrinsic"
                                style={{
                                    position: 'absolute',
                                    inset: '0px',
                                    boxSizing: 'border-box',
                                    padding: '0px',
                                    border: 'none',
                                    margin: 'auto',
                                    display: 'block',
                                    width: '0px',
                                    height: '0px',
                                    minWidth: '100%',
                                    maxWidth: '100%',
                                    minHeight: '100%',
                                    maxHeight: '100%'
                                }} />
                        </span>
                    </span>
                    Gửi ý kiến
                </button>
            </div>

            <div className="styles_filterComment__UDHOg MuiBox-root css-0">
                <p className="MuiTypography-root styles_filterHeading__Wceo0 MuiTypography-body1">
                    Lọc theo
                </p>

                <div
                    className="MuiFormGroup-root styles_btnGroup__s4AYh MuiFormGroup-row"
                    role="radiogroup"
                >
                    {/* --- MỚI NHẤT --- */}
                    <label className="MuiFormControlLabel-root">
                        <span
                            className={`MuiButtonBase-root MuiIconButton-root jss35 MuiRadio-root MuiRadio-colorSecondary MuiIconButton-colorSecondary
                                ${activeRadio === false
                                    ? "jss36 Mui-checked"
                                    : ""
                                }`}
                            aria-disabled="false"
                            onClick={() => setActiveRadio(false)}
                        >
                            <span className="MuiIconButton-label">

                                <input
                                    className="jss38"
                                    type="radio"
                                    value="NEWEST"
                                    name="mui-1575"
                                    defaultChecked
                                />

                                <div className="jss39 jss41">
                                    <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
                                    </svg>

                                    <svg className="MuiSvgIcon-root jss40" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"></path>
                                    </svg>
                                </div>
                            </span>

                            <span className="MuiTouchRipple-root"></span>
                        </span>

                        <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">
                            Mới nhất
                        </span>
                    </label>

                    {/* --- CŨ NHẤT --- */}
                    <label className="MuiFormControlLabel-root">
                        <span
                            className={`MuiButtonBase-root MuiIconButton-root jss35 MuiRadio-root MuiRadio-colorSecondary MuiIconButton-colorSecondary
                                ${activeRadio
                                    ? "jss36 Mui-checked"
                                    : ""
                                }`}
                            onClick={() => setActiveRadio(true)}
                            aria-disabled="false"
                        >
                            <span className="MuiIconButton-label">

                                <input
                                    className="jss38"
                                    type="radio"
                                    value="OLDEST"
                                    name="mui-1575"
                                />

                                <div className="jss39">
                                    <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
                                    </svg>

                                    <svg className="MuiSvgIcon-root jss40" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"></path>
                                    </svg>
                                </div>
                            </span>

                            <span className="MuiTouchRipple-root"></span>
                        </span>

                        <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">
                            Cũ nhất
                        </span>
                    </label>
                </div>
            </div>

            <div className="styles_mainComment__7SwfO MuiBox-root css-0">
                <div className="styles_readMoreWrapper__26uhD">
                    <ul className="MuiList-root styles_commentList__byBaU MuiList-padding">

                        <li className="MuiListItem-root styles_commentItem__nWOGk">

                            <div className="styles_commentInner__tt6x7 MuiBox-root css-0">

                                {/* Avatar */}
                                <div className="styles_commentAvatar__fa0Mc styles_hasChildBranch__weVqR MuiBox-root css-0">

                                    <span style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%"
                                    }}>
                                        <span style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                            maxWidth: "100%"
                                        }}>
                                            <img
                                                alt=""
                                                aria-hidden="true"
                                                src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e"
                                                style={{
                                                    display: "block",
                                                    maxWidth: "100%",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0
                                                }}
                                            />
                                        </span>

                                        <img
                                            src="https://cdn-web-next.thuocsi.vn/images/customerv2_avatar_qa.svg"
                                            decoding="async"
                                            data-nimg="intrinsic"
                                            className="styles_commentAvatarImg__jlxDQ"
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                boxSizing: "border-box",
                                                padding: 0,
                                                border: "none",
                                                margin: "auto",
                                                display: "block",
                                                width: 0,
                                                height: 0,
                                                minWidth: "100%",
                                                maxWidth: "100%",
                                                minHeight: "100%",
                                                maxHeight: "100%"
                                            }}
                                        />

                                    </span>
                                </div>

                                {/* Content */}
                                <div className="styles_commentInfo__VUjW7 MuiBox-root css-0">

                                    <h4 className="MuiTypography-root styles_commentName__X_cRE MuiTypography-h4">
                                        Vương Bảo Châu
                                    </h4>

                                    <div className="styles_commentContent__jaaOa">
                                        Cồn này có mùi gì vậy ạ?
                                    </div>

                                    <div className="styles_commentUtils__pwwsc">

                                        <span className="styles_commentTime___jR8W">
                                            7 tháng trước
                                        </span>

                                        <div role="button" className="styles_commentReply__JftrS" onClick={() => setIsShowCommentB1(true)}>
                                            <span style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "relative",
                                                maxWidth: "100%"
                                            }}>

                                                <span style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    maxWidth: "100%"
                                                }}>
                                                    <img
                                                        alt=""
                                                        aria-hidden="true"
                                                        src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2720%27%20height=%2720%27/%3e"
                                                        style={{
                                                            display: "block",
                                                            maxWidth: "100%",
                                                            width: "initial",
                                                            height: "initial",
                                                            background: "none",
                                                            opacity: 1,
                                                            border: 0,
                                                            margin: 0,
                                                            padding: 0
                                                        }}
                                                    />
                                                </span>

                                                <img
                                                    alt="reply icon"
                                                    src="https://cdn-web-next.thuocsi.vn/images/reply_qa.svg"
                                                    decoding="async"
                                                    data-nimg="intrinsic"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%"
                                                    }}
                                                />
                                            </span>

                                            Trả lời
                                        </div>
                                    </div>
                                </div>

                            </div>
                            {isShowCommentB1 && (
                                <div
                                    className="styles_hasReplies__u4ALo styles_replyInput__9WyqP styles_replyInput-type-COMMENT__Q_7lM MuiBox-root css-0"
                                    style={{ paddingLeft: 40 }}
                                >

                                    {/* Avatar */}
                                    <div className="styles_replyAvatar__YJ14U MuiBox-root css-0">

                                        <span
                                            style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "relative",
                                                maxWidth: "100%"
                                            }}
                                        >
                                            <span
                                                style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    maxWidth: "100%"
                                                }}
                                            >
                                                <img
                                                    alt=""
                                                    aria-hidden="true"
                                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e"
                                                    style={{
                                                        display: "block",
                                                        maxWidth: "100%",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0
                                                    }}
                                                />
                                            </span>

                                            <img
                                                alt="avatar reply"
                                                src="https://cdn-web-next.thuocsi.vn/images/customerv2_avatar_qa.svg"
                                                decoding="async"
                                                data-nimg="intrinsic"
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    boxSizing: "border-box",
                                                    padding: 0,
                                                    border: "none",
                                                    margin: "auto",
                                                    display: "block",
                                                    width: 0,
                                                    height: 0,
                                                    minWidth: "100%",
                                                    maxWidth: "100%",
                                                    minHeight: "100%",
                                                    maxHeight: "100%"
                                                }}
                                            />
                                        </span>
                                    </div>

                                    {/* Reply form content */}

                                    <div className="styles_replyInfo__Pyi5E MuiBox-root css-0">

                                        <h4 className="MuiTypography-root styles_replyName__cFBJi MuiTypography-h4">
                                            Đang phản hồi: <span>Vương Bảo Châu</span>
                                        </h4>

                                        <form className="styles_replyForm__RhKnd">

                                            <div className="styles_replyFormInput__Mekc6 MuiBox-root css-0">

                                                <div className="styles_formTextarea__tEzx5 MuiBox-root css-0">

                                                    <textarea
                                                        rows={2}
                                                        className="styles_input__guBXf"
                                                        maxLength={200}
                                                        placeholder="* Vui lòng nhập nội dung phản hồi bằng tiếng Việt có dấu, tối thiểu 3 ký tự (Bắt buộc)"
                                                        name="reply"
                                                        style={{ height: 64 }}
                                                    />

                                                    <textarea
                                                        aria-hidden="true"
                                                        className="styles_input__guBXf"
                                                        readOnly
                                                        tabIndex={-1}
                                                        style={{
                                                            visibility: "hidden",
                                                            position: "absolute",
                                                            overflow: "hidden",
                                                            height: 0,
                                                            top: 0,
                                                            left: 0,
                                                            transform: "translateZ(0px)",
                                                            width: 879.031
                                                        }}
                                                    />

                                                    <div className="styles_textareaCount__dhFX3">
                                                        0/ 200
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="styles_submit__KDOGl MuiBox-root css-0">
                                                <button
                                                    className="styles_base__Pdm9S styles_contained__4kDf4 styles_colorSecondary__js_Iq styles_small__QTUmD"
                                                    type="button"
                                                    onClick={() => setIsShowCommentB1(false)}
                                                >
                                                    Gửi phản hồi
                                                </button>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            )}
                            <div className="styles_loadMoreReply__0gNh3 styles_readMoreWrapper__26uhD">

                                <li
                                    className="MuiListItem-root styles_commentItem__nWOGk styles_subCommentItem___bLrj"
                                    id="REPLY-13447"
                                    style={{ paddingLeft: 40 }}
                                >

                                    <div className="styles_commentInner__tt6x7 MuiBox-root css-0">

                                        {/* Avatar */}
                                        <div className="styles_commentAvatar__fa0Mc MuiBox-root css-0">

                                            <span style={{
                                                boxSizing: "border-box",
                                                display: "inline-block",
                                                overflow: "hidden",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                                position: "relative",
                                                maxWidth: "100%"
                                            }}>
                                                <span style={{
                                                    boxSizing: "border-box",
                                                    display: "block",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    maxWidth: "100%"
                                                }}>
                                                    <img
                                                        alt=""
                                                        aria-hidden="true"
                                                        src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e"
                                                        style={{
                                                            display: "block",
                                                            maxWidth: "100%",
                                                            width: "initial",
                                                            height: "initial",
                                                            background: "none",
                                                            opacity: 1,
                                                            border: 0,
                                                            margin: 0,
                                                            padding: 0
                                                        }}
                                                    />
                                                </span>

                                                <img
                                                    src="https://cdn-web-next.thuocsi.vn/images/employee_avatar_qa.svg"
                                                    decoding="async"
                                                    data-nimg="intrinsic"
                                                    className="styles_commentAvatarImg__jlxDQ"
                                                    style={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        boxSizing: "border-box",
                                                        padding: 0,
                                                        border: "none",
                                                        margin: "auto",
                                                        display: "block",
                                                        width: 0,
                                                        height: 0,
                                                        minWidth: "100%",
                                                        maxWidth: "100%",
                                                        minHeight: "100%",
                                                        maxHeight: "100%"
                                                    }}
                                                />
                                            </span>
                                        </div>

                                        {/* Info */}
                                        <div className="styles_commentInfo__VUjW7 MuiBox-root css-0">

                                            <h4 className="MuiTypography-root styles_commentName__X_cRE MuiTypography-h4">
                                                Buymed - hỗ trợ

                                                <span style={{
                                                    boxSizing: "border-box",
                                                    display: "inline-block",
                                                    overflow: "hidden",
                                                    width: "initial",
                                                    height: "initial",
                                                    background: "none",
                                                    opacity: 1,
                                                    border: 0,
                                                    margin: 0,
                                                    padding: 0,
                                                    position: "relative",
                                                    maxWidth: "100%"
                                                }}>
                                                    <span style={{
                                                        boxSizing: "border-box",
                                                        display: "block",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        maxWidth: "100%"
                                                    }}>
                                                        <img
                                                            alt=""
                                                            aria-hidden="true"
                                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2712%27%20height=%2712%27/%3e"
                                                            style={{
                                                                display: "block",
                                                                maxWidth: "100%",
                                                                width: "initial",
                                                                height: "initial",
                                                                background: "none",
                                                                opacity: 1,
                                                                border: 0,
                                                                margin: 0,
                                                                padding: 0
                                                            }}
                                                        />
                                                    </span>

                                                    <img
                                                        src="https://cdn-web-next.thuocsi.vn/images/authen_qa.svg"
                                                        decoding="async"
                                                        data-nimg="intrinsic"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%"
                                                        }}
                                                    />
                                                </span>
                                            </h4>

                                            {/* Content */}
                                            <div className="styles_commentContent__jaaOa">
                                                <p className="!mb-0">
                                                    Chào Nhà thuốc, sản phẩm
                                                    <a href="https://internal.thuocsi.vn/cms/product?search=92802" target="_self">
                                                        {" "}
                                                        Cồn 75 độ direh perfect havico (C/1000ml)
                                                    </a>{" "}
                                                    không hương liệu nên khi sử dụng sẽ không có mùi, đặc trưng chủ yếu sẽ có thoảng mùi cồn nhẹ.
                                                </p>
                                            </div>

                                            {/* Utils */}
                                            <div className="styles_commentUtils__pwwsc">

                                                <span className="styles_commentTime___jR8W">
                                                    7 tháng trước
                                                </span>

                                                <div role="button" className="styles_commentReply__JftrS" onClick={() => setIsShowCommentB2(true)}>

                                                    <span style={{
                                                        boxSizing: "border-box",
                                                        display: "inline-block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "relative",
                                                        maxWidth: "100%"
                                                    }}>

                                                        <span style={{
                                                            boxSizing: "border-box",
                                                            display: "block",
                                                            width: "initial",
                                                            height: "initial",
                                                            background: "none",
                                                            opacity: 1,
                                                            border: 0,
                                                            margin: 0,
                                                            padding: 0,
                                                            maxWidth: "100%"
                                                        }}>
                                                            <img
                                                                alt=""
                                                                aria-hidden="true"
                                                                src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2720%27%20height=%2720%27/%3e"
                                                                style={{
                                                                    display: "block",
                                                                    maxWidth: "100%",
                                                                    width: "initial",
                                                                    height: "initial",
                                                                    background: "none",
                                                                    opacity: 1,
                                                                    border: 0,
                                                                    margin: 0,
                                                                    padding: 0
                                                                }}
                                                            />
                                                        </span>

                                                        <img
                                                            alt="reply icon"
                                                            src="https://cdn-web-next.thuocsi.vn/images/reply_qa.svg"
                                                            decoding="async"
                                                            data-nimg="intrinsic"
                                                            style={{
                                                                position: "absolute",
                                                                inset: 0,
                                                                boxSizing: "border-box",
                                                                padding: 0,
                                                                border: "none",
                                                                margin: "auto",
                                                                display: "block",
                                                                width: 0,
                                                                height: 0,
                                                                minWidth: "100%",
                                                                maxWidth: "100%",
                                                                minHeight: "100%",
                                                                maxHeight: "100%"
                                                            }}
                                                        />

                                                    </span>

                                                    Trả lời
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    {isShowCommentB2 && (
                                        <div
                                            className="styles_replyInput__9WyqP styles_replyInput-type-REPLY__MqRB6 MuiBox-root css-0"
                                            style={{ paddingLeft: 0 }}
                                        >
                                            <div className="styles_replyAvatar__YJ14U MuiBox-root css-0">

                                                <span
                                                    style={{
                                                        boxSizing: "border-box",
                                                        display: "inline-block",
                                                        overflow: "hidden",
                                                        width: "initial",
                                                        height: "initial",
                                                        background: "none",
                                                        opacity: 1,
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        position: "relative",
                                                        maxWidth: "100%"
                                                    }}
                                                >

                                                    <span
                                                        style={{
                                                            boxSizing: "border-box",
                                                            display: "block",
                                                            width: "initial",
                                                            height: "initial",
                                                            background: "none",
                                                            opacity: 1,
                                                            border: 0,
                                                            margin: 0,
                                                            padding: 0,
                                                            maxWidth: "100%"
                                                        }}
                                                    >
                                                        <img
                                                            alt=""
                                                            aria-hidden="true"
                                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e"
                                                            style={{
                                                                display: "block",
                                                                maxWidth: "100%",
                                                                width: "initial",
                                                                height: "initial",
                                                                background: "none",
                                                                opacity: 1,
                                                                border: 0,
                                                                margin: 0,
                                                                padding: 0
                                                            }}
                                                        />
                                                    </span>

                                                    <img
                                                        alt="avatar reply"
                                                        src="https://cdn-web-next.thuocsi.vn/images/customerv2_avatar_qa.svg"
                                                        decoding="async"
                                                        data-nimg="intrinsic"
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            boxSizing: "border-box",
                                                            padding: 0,
                                                            border: "none",
                                                            margin: "auto",
                                                            display: "block",
                                                            width: 0,
                                                            height: 0,
                                                            minWidth: "100%",
                                                            maxWidth: "100%",
                                                            minHeight: "100%",
                                                            maxHeight: "100%"
                                                        }}
                                                    />

                                                </span>
                                            </div>

                                            <div className="styles_replyInfo__Pyi5E MuiBox-root css-0">

                                                <h4 className="MuiTypography-root styles_replyName__cFBJi MuiTypography-h4">
                                                    Đang phản hồi: <span>Buymed - hỗ trợ</span>
                                                </h4>

                                                <form className="styles_replyForm__RhKnd">

                                                    <div className="styles_replyFormInput__Mekc6 MuiBox-root css-0">

                                                        <div className="styles_formTextarea__tEzx5 MuiBox-root css-0">

                                                            <textarea
                                                                rows={2}
                                                                className="styles_input__guBXf"
                                                                maxLength={200}
                                                                placeholder="* Vui lòng nhập nội dung phản hồi bằng tiếng Việt có dấu, tối thiểu 3 ký tự (Bắt buộc)"
                                                                name="reply"
                                                                style={{ height: 64 }}
                                                            />

                                                            <textarea
                                                                aria-hidden="true"
                                                                className="styles_input__guBXf"
                                                                readOnly
                                                                tabIndex={-1}
                                                                style={{
                                                                    visibility: "hidden",
                                                                    position: "absolute",
                                                                    overflow: "hidden",
                                                                    height: 0,
                                                                    top: 0,
                                                                    left: 0,
                                                                    transform: "translateZ(0px)",
                                                                    width: 879.031
                                                                }}
                                                            />

                                                            <div className="styles_textareaCount__dhFX3">
                                                                0/ 200
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="styles_submit__KDOGl MuiBox-root css-0">
                                                        <button
                                                            className="styles_base__Pdm9S styles_contained__4kDf4 styles_colorSecondary__js_Iq styles_small__QTUmD"
                                                            type="button"
                                                            onClick={() => setIsShowCommentB2(false)}
                                                        >
                                                            Gửi phản hồi
                                                        </button>
                                                    </div>

                                                </form>

                                            </div>
                                        </div>
                                    )}
                                    {/* empty div at bottom (giữ nguyên như HTML gốc) */}

                                    <div className="styles_loadMoreReply__0gNh3 styles_readMoreWrapper__26uhD"></div>
                                </li>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            {open && <SendModalComponent onClose={() => setOpen(false)} />}
        </div>
    )
}
